import { LazyLoadImage } from "react-lazy-load-image-component";
import attentionImg from "../../assets/img/attention.png";
export default function Attention() {
    return (
        <div className="bg-bprDarkBlue opacity-95">
            <div className="max-w-screen-2xl mx-auto pt-16 pb-1 p-4 md:p-5 lg:px-16 ">
                <div className="flex items-center justify-center text-white">
                    <LazyLoadImage
                        src={attentionImg}
                        alt="produk-1"
                        effect="blur"
                        className="w-auto h-auto"
                        wrapperProps={{
                            style: { transitionDelay: '1s' },
                        }}
                    >

                    </LazyLoadImage>
                    <div><b className="font-poppinsBold">PERHATIAN </b><span className="font-poppinsRegular text-sm">BPR Palu Anugerah tidak memungut biaya apapun selama proses pendaftaran dan seleksi karir berlangsung</span></div>
                </div>
            </div>
        </div>

    )

}